var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.alert.open
        ? _c("emd-alert", {
            staticClass: "eu-mt_5",
            attrs: {
              variant: _vm.alert.variant,
              title: _vm.alert.msg,
              noClose: true,
            },
            on: { cancel: _vm.handleAlertModalClose },
          })
        : _vm._e(),
      _c("general-info-card", {
        staticClass: "eu-my_5",
        attrs: { data: _vm.dataGeneralInfo },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _vm.showButtonCancelLink
                  ? _c(
                      "emd-button",
                      {
                        attrs: {
                          color: "primary",
                          size: "small",
                          disabled: _vm.loadingCancel,
                        },
                        on: { click: _vm.handleOpenModal },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("cancelLink")) + " ")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "modal",
            fn: function () {
              return [
                _c("confirm-cancel-modal", {
                  attrs: {
                    isModalOpen: _vm.isModalOpen,
                    isActionDisabled: _vm.loadingCancel,
                  },
                  on: {
                    confirmClick: _vm.handleCancelLink,
                    closeClick: _vm.handleCloseModal,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("configuration-card", {
        staticClass: "eu-my_5",
        attrs: { data: _vm.dataConfiguration },
      }),
      _c("payment-methods-card", {
        staticClass: "eu-my_5",
        attrs: { data: _vm.dataPaymentMethods },
      }),
      _c("items-card", {
        staticClass: "eu-my_5",
        attrs: { data: _vm.dataItems },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }